<dashboard-dialog-frame class="assigned-staff-dialog" [header]="headerText()" icon="fa-user-gear" [actions]="actions()" (closed)="closeDialog()" [dialogRef]="dialogRef">

	<div class="d-flex flex-column gap-3 p-3">
		<p class="text-muted mb-3">Assigned Staff Member</p>

		<staff-selector-widget [disabled]="false" [data]="staffData()" [userId]="app.data().user.userId"
			[value]="selectedStaff()" (valueChange)="handleStaffValueChange($event)"></staff-selector-widget>
	</div>

</dashboard-dialog-frame>